import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const ServiceProvider = Loadable(lazy(() => import('./ServiceProvider')));
const ServiceProviderDetails = Loadable(lazy(() => import('./SubPages/ServiceProviderDetails')));
const ServiceProviderDocuments = Loadable(lazy(() => import('./SubPages/ServiceProviderDocuments')));
const ServiceProviderAssignments = Loadable(lazy(() => import('./SubPages/ServiceProviderAssignments')));
const CreateProvider = Loadable(lazy(() => import('./CRUD/CreateProvider')));
const UpdateProvider = Loadable(lazy(() => import('./CRUD/UpdateProvider')));
const ServiceProviderTips = Loadable(lazy(() => import('./SubPages/serviceProviderTips')));
const ServiceProviderTransactions = Loadable(lazy(() => import('./SubPages/ServiceProviderTransactions')));
const CalendarLeaves = Loadable(lazy(() => import('./SubPages/WorkCalendar')));
const WorkingHours = Loadable(lazy(() => import('./SubPages/WorkHours')));

const servicesProviderRoutes = [
  { path: '/dashboard/service-providers', element: <ServiceProvider />, auth: authRoles.admin },
  {
    path: '/dashboard/service-providers/create',
    element: <CreateProvider />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/service-providers/:id/details',
    element: <ServiceProviderDetails />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/service-providers/:id/documents',
    element: <ServiceProviderDocuments />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/service-providers/:id/assignments',
    element: <ServiceProviderAssignments />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/service-providers/:id/update',
    element: <UpdateProvider />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/service-providers/:id/tips',
    element: <ServiceProviderTips />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/service-providers/:id/transactions',
    element: <ServiceProviderTransactions />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/service-providers/:id/work_calendar/',
    element: <CalendarLeaves />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/service-providers/:id/work_hours/',
    element: <WorkingHours />,
    auth: authRoles.admin,
  },
];

export default servicesProviderRoutes;
